<template>
  <v-autocomplete
    v-model="internalModel"
    :items="items"
    :search-input.sync="search"
    :loading="isLoading"
    :label="internalModel ? internalModel.libelle : defaultValue"
    :error-messages="errors"
    hide-details="auto"
    hide-no-data
    hide-selected
    placeholder="Remplacer par... (saisir une partie du nom)"
    item-text="libelle"
    item-value="id"
    @input="vac_Input"
    return-object
    filled
    single-line
    dense
  ></v-autocomplete>
</template>

<script>
import FournisseurService from "@/services/FournisseurService";

export default {
  props: {
    kind: {
      type: String,
      default: "denos",
    },
    defaultValue: {
      type: String,
      default: "",
    },
    errors: {
      type: Array,
    },
  },
  data: () => ({
    descriptionLimit: 60,
    entries: [],
    isLoading: false,
    internalModel: null,
    search: null,
  }),

  computed: {
    items() {
      //Transformation des entries reçues de l'api si nécessaire.
      switch (this.kind) {
        case "denos":
          return this.entries.map((entry) => {
            const libelle = entry.denoPrincipale
              ? entry.denoPrincipale + ` (${entry.libelle})`
              : entry.libelle;
            return Object.assign({}, entry, { libelle });
          });

        default:
          return this.entries;
      }
    },
  },

  watch: {
    search(val) {
      if (val == null || val == "") return;
      if (this.isLoading) return;

      this.isLoading = true;
      //console.log(val);

      // if (!val) {
      //   this.isLoading = false;
      //   return;
      // }

      FournisseurService.getDenominationsPourProduit({ q: val })
        .then((res) => {
          this.entries = res.data;
        })
        .catch((err) => {
          if (
            err.response &&
            err.response.status &&
            err.response.status == 401
          ) {
            this.$store.dispatch(
              "setErreur",
              new Error("Vous avez été déconnecté.e")
            );
            this.$router.replace({ name: "home" });
          } else if (
            err.response &&
            err.response.status &&
            err.response.status == 404
          ) {
            this.entries = [];
          } else {
            this.$store.dispatch("setErreur", err);
          }
        })
        .finally(() => (this.isLoading = false));
    },
  },
  methods: {
    vac_Input(val) {
      //console.log("vac_Input.val", val);
      this.$emit("input", val.id);
    },
  },
};
</script>

<style></style>
